import type Store from "@ember-data/store";
import Route from "@ember/routing/route";
import type RouterService from "@ember/routing/router-service";
import type Transition from "@ember/routing/transition";
import { service } from "@ember/service";
import BloodPressureSessionModelView from "parog-web/models/blood-pressure-session-model-view";
import type BloodPressureSessionStartedJournalEvent from "parog-web/models/blood-pressure-session-started-journal-event";
import type FetcherService from "parog-web/services/fetcher";
import type NavigationService from "parog-web/services/navigation";
import ControlTower from "wise-control-tower";

export default class BloodPressureSessionRoute extends Route<BloodPressureSessionModelView> {
  @service declare router: RouterService;
  @service declare store: Store;
  @service declare fetcher: FetcherService;
  @service declare navigation: NavigationService;

  async beforeModel({ to }: Transition): Promise<void> {
    if (!to) return;
    const { session_id } = to.params as Record<string, any>;

    if (!session_id) {
      this.router.transitionTo("patient-web.protected.blood-pressure.sessions");
    }
  }

  async model(params): Promise<BloodPressureSessionModelView> {
    const sessionId = params["session_id"];

    const session = (await this.store
      .findRecord("blood-pressure-session-started-journal-event", sessionId, {
        include: "blood-pressure-measured-journal-events"
      })
      .catch(e => {
        ControlTower.captureException(e);
      })) as BloodPressureSessionStartedJournalEvent;

    return new BloodPressureSessionModelView(
      this.store,
      this.fetcher,
      session,
      session.patient
    );
  }
}
